import { genererCorrelationId } from "../correlation-id/correlation-id.service";
import { sessionId } from "../session-id/session-id.service";

export interface DffErrorParams {
    friendlyMessage?: string;
    innerError?: any;
    correlationId?: string;
    showNotification?: boolean;
    /** Spring over ErrorHandler/Rapid7-log (fx forventet 401 der allerede er logget i interceptor). */
    suppressLog?: boolean;
}

export class DffError extends Error {
    public readonly correlationId: string;
    public readonly friendlyMessage: string;
    public readonly showNotification: boolean;
    public readonly suppressLog: boolean;

    constructor(message: string, private readonly params: DffErrorParams = {}) {
        super(message);
        Object.setPrototypeOf(this, DffError.prototype);
        this.name = "DffError";

        this.correlationId =
            this.params.correlationId || (this.params.innerError && this.params.innerError.correlationId) || genererCorrelationId();
        this.friendlyMessage = params.friendlyMessage || "";
        this.showNotification = !!params.showNotification;
        this.suppressLog = !!params.suppressLog;
    }

    public get logId(): string {
        return `${sessionId}-${this.correlationId}`;
    }
}
